import { memo } from 'react';

const CategoryPills = memo(({ mapTags, selectedCategory, setSelectedCategory }) => {
  return (
    <div className="absolute top-[112px] left-0 right-0 z-[400] px-4 overflow-x-auto scrollbar-hide md:flex md:justify-center">
      <div className="flex gap-2 pb-2 min-w-max md:min-w-0">
        {mapTags.map(tag => {
          const active = selectedCategory === tag.name;
          return (
            <button
              key={tag.name}
              // Re-click on the active pill clears the filter back to 'All'.
              onClick={() => setSelectedCategory(active ? 'All' : tag.name)}
              aria-pressed={active}
              className={`px-3 py-1.5 rounded-full text-sm font-medium shadow-md transition-all whitespace-nowrap ${
                active
                  ? 'bg-primary text-white'
                  : 'bg-background text-foreground hover:bg-accent border border-border'
              }`}
            >
              {tag.name}
            </button>
          );
        })}
      </div>
    </div>
  );
});

export default CategoryPills;
